export default __webpack_public_path__ + "static/media/screen.59867df3.svg";